'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.
const path = require('path')
const PresentType = true; //true 为H5模式 false为app模式 --修改后重启
const H5Path = 'http://equipment.rjhtc.com.cn:8083';
// const H5Path = 'http://equipment.rjhtc.com.cn:8083';
const HospitalCode = 'LJSXCYYRJYYTCFY';
//http://www.api.zlianyx.com/
//http://localhost:5628/
//http://www.api.huiyxx.com/

// API域名配置
const API_CONFIG = {
    // 主API服务器 - 用于大部分接口
    // mainApi: 'http://equipment.rjhtc.com.cn:8081',
    // mainApi: 'http://localhost:5628/',
    mainApi: 'http://www.api.huiyxx.com/',

    // 文件上传服务器 - 特殊端口5803
    fileUploadApi: 'http://equipmentH5.rjhtc.com.cn:8310',

    // 文件存储服务器 - 用于文件访问
    fileServer: 'http://equipment.rjhtc.com.cn:8082'
};
module.exports = {
    PresentType: PresentType,
    H5Path: H5Path,
    HospitalCode: HospitalCode,
    api: API_CONFIG,
    dev: {
        assetsSubDirectory: 'static',
        assetsPublicPath: '/',
        proxyTable: PresentType ? {
            '/api': {
                target: API_CONFIG.mainApi,
                // target:'http://localhost:5628/',
                changeOrigin: true,
                pathRewrite: {
                    '^/api': ''
                }
            }

        } : {},

        // Various Dev Server settings
        host: 'localhost', // can be overwritten by process.env.HOST
        port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
        autoOpenBrowser: false,
        errorOverlay: true,
        notifyOnErrors: true,
        poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-
        /**
         * Source Maps
         */

        // https://webpack.js.org/configuration/devtool/#development
        devtool: 'cheap-module-eval-source-map',

        // If you have problems debugging vue-files in devtools,
        // set this to false - it *may* help
        // https://vue-loader.vuejs.org/en/options.html#cachebusting
        cacheBusting: true,
        cssSourceMap: true
    },

    build: {
        // Template for index.html
        index: path.resolve(__dirname, '../dist/index.html'),

        // Paths
        assetsRoot: path.resolve(__dirname, '../dist'),
        assetsSubDirectory: 'static',
        assetsPublicPath: PresentType ? '/' : './', //判断当前模式进行路径选择

        /**
         * Source Maps
         */

        productionSourceMap: true,
        // https://webpack.js.org/configuration/devtool/#production
        devtool: '#source-map',

        // Gzip off by default as many popular static hosts such as
        // Surge or Netlify already gzip all static assets for you.
        // Before setting to `true`, make sure to:
        // npm install --save-dev compression-webpack-plugin
        productionGzip: false,
        productionGzipExtensions: ['js', 'css'],

        // Run the build command with an extra argument to
        // View the bundle analyzer report after build finishes:
        // `npm run build --report`
        // Set to `true` or `false` to always turn it on or off
        bundleAnalyzerReport: process.env.npm_config_report
    }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1